module.exports = __webpack_public_path__ + "img/MDC_Gamutstar_gross.67e31609.png";